import { inject, Provider } from '@angular/core';

import { Cb2PreviewStateService } from '@core/services/cb2-preview/cb2-preview-state.service';

import {
  KIOSK_ORDER_STATUS_BLOCK_DATA_SOURCE,
  KioskOrderStatusBlockDataSource,
} from './kiosk-order-status-block-view-model';
import { KioskOrderStatusBlockPreviewDataSource } from './kiosk-order-status-block-preview-data-source';
import { KioskOrderStatusBlockStoreDataSource } from './kiosk-order-status-block-store-data-source';

export function provideKioskOrderStatusBlockDataSource(): Provider[] {
  return [
    KioskOrderStatusBlockStoreDataSource,
    KioskOrderStatusBlockPreviewDataSource,
    {
      provide: KIOSK_ORDER_STATUS_BLOCK_DATA_SOURCE,
      useFactory: (): KioskOrderStatusBlockDataSource => {
        const previewState = inject(Cb2PreviewStateService);
        return previewState.isActive()
          ? inject(KioskOrderStatusBlockPreviewDataSource)
          : inject(KioskOrderStatusBlockStoreDataSource);
      },
    },
  ];
}
